// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import { httpsCallable } from "firebase/functions";
// import { functions } from "../firebase";

// export default function PublicLogView() {
//   const { publicId } = useParams();

//   // data state
//   const [loading, setLoading] = useState(true);
//   const [log, setLog] = useState(null);
//   const [events, setEvents] = useState([]);
//   const [canRespond, setCanRespond] = useState(false);
//   const [error, setError] = useState("");

//   // ui flow state
//   const [step, setStep] = useState("VIEW"); // VIEW | EMAIL | OTP | DONE
//   const [action, setAction] = useState(null); // AGREE | DISAGREE
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState("");
//   const [busy, setBusy] = useState(false);

//   // ===============================
//   // LOAD PUBLIC LOG
//   // ===============================
//   const fetchPublic = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const fn = httpsCallable(functions, "getPublicLog");
//       const res = await fn({ publicId });

//       setLog(res.data.log || null);
//       setEvents(res.data.events || []);
//       setCanRespond(Boolean(res.data.canRespond));
//     } catch (err) {
//       console.error("getPublicLog error:", err);
//       setError(
//         err?.message ||
//         err?.details ||
//         "Failed to load public log"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPublic();
//     // eslint-disable-next-line
//   }, [publicId]);

//   // ===============================
//   // SEND OTP (STEP 1)
//   // ===============================
//   const sendOtp = async () => {
//     // 🛑 HARD GUARDS (THIS FIXES YOUR 500)
//     if (!action) {
//       alert("Action missing. Please click Agree or Disagree again.");
//       return;
//     }

//     if (!email.trim()) {
//       alert("Please enter your email");
//       return;
//     }

//     setBusy(true);
//     setError("");

//     try {
//       const fn = httpsCallable(functions, "sendEmailOtp");
//       await fn({ publicId, email, action });

//       // ✅ move to OTP step only on success
//       setStep("OTP");
//     } catch (err) {
//       console.error("sendEmailOtp error:", err);
//       setError(
//         err?.message ||
//         err?.details ||
//         "Failed to send OTP"
//       );
//     } finally {
//       setBusy(false);
//     }
//   };

//   // ===============================
//   // VERIFY OTP (STEP 2)
//   // ===============================
//   const verifyOtp = async () => {
//     if (!otp.trim()) {
//       alert("Please enter the OTP");
//       return;
//     }

//     setBusy(true);
//     setError("");

//     try {
//       const fn = httpsCallable(functions, "verifyEmailOtpAndRespond");
//       await fn({ publicId, email, otp });

//       setStep("DONE");
//       await fetchPublic();
//     } catch (err) {
//       console.error("verifyEmailOtpAndRespond error:", err);
//       setError(
//         err?.message ||
//         err?.details ||
//         "OTP verification failed"
//       );
//     } finally {
//       setBusy(false);
//     }
//   };

//   // ===============================
//   // UI STATES
//   // ===============================
//   if (loading) {
//     return <div style={{ padding: 40 }}>Loading…</div>;
//   }

//   if (error) {
//     return (
//       <div style={{ padding: 40, color: "red" }}>
//         {error}
//       </div>
//     );
//   }

//   if (!log) {
//     return <div style={{ padding: 40 }}>Log not found</div>;
//   }

//   // ===============================
//   // RENDER
//   // ===============================
//   return (
//     <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
//       <h2>Public Log</h2>

//       {/* LOG SUMMARY */}
//       <div
//         style={{
//           border: "1px solid #ddd",
//           borderRadius: 12,
//           padding: 14,
//         }}
//       >
//         <div style={{ fontWeight: 800, fontSize: 18 }}>
//           {log.title}
//         </div>

//         {log.note && (
//           <div style={{ marginTop: 6 }}>{log.note}</div>
//         )}

//         <div style={{ marginTop: 10, fontSize: 12, opacity: 0.7 }}>
//           Expired: {String(Boolean(log.expired))}
//         </div>
//       </div>

//       {/* TIMELINE */}
//       <h3 style={{ marginTop: 20 }}>Timeline</h3>
//       <div
//         style={{
//           border: "1px solid #eee",
//           borderRadius: 12,
//           padding: 12,
//         }}
//       >
//         {events.length === 0 ? (
//           <div>No events yet</div>
//         ) : (
//           events.map((ev) => (
//             <div key={ev.id} style={{ padding: "8px 0" }}>
//               <b>{ev.event_type}</b>
//               <div style={{ fontSize: 12, opacity: 0.7 }}>
//                 {ev.timestamp?.toDate
//                   ? ev.timestamp.toDate().toLocaleString()
//                   : ""}
//               </div>
//             </div>
//           ))
//         )}
//       </div>

//       {/* ACTION BUTTONS */}
//       {step === "VIEW" && canRespond && (
//         <div style={{ marginTop: 18, display: "flex", gap: 10 }}>
//           <button
//             onClick={() => {
//               setAction("AGREE");
//               setStep("EMAIL");
//             }}
//           >
//             ✅ Agree
//           </button>

//           <button
//             onClick={() => {
//               setAction("DISAGREE");
//               setStep("EMAIL");
//             }}
//           >
//             ❌ Disagree
//           </button>

//           <button onClick={() => alert("Ignored. No action recorded.")}>
//             😶 Ignore
//           </button>
//         </div>
//       )}

//       {/* EMAIL STEP */}
//       {step === "EMAIL" && (
//         <div style={{ marginTop: 20 }}>
//           <h4>Email verification</h4>

//           <input
//             type="email"
//             placeholder="Enter your email"
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//             style={{ padding: 8, width: 260 }}
//           />

//           <br /><br />

//           <button disabled={busy} onClick={sendOtp}>
//             {busy ? "Sending…" : "Send OTP"}
//           </button>
//         </div>
//       )}

//       {/* OTP STEP */}
//       {step === "OTP" && (
//         <div style={{ marginTop: 20 }}>
//           <h4>Enter OTP</h4>

//           <input
//             type="text"
//             placeholder="6-digit OTP"
//             value={otp}
//             onChange={(e) => setOtp(e.target.value)}
//             style={{ padding: 8, width: 180 }}
//           />

//           <br /><br />

//           <button disabled={busy} onClick={verifyOtp}>
//             {busy ? "Verifying…" : "Verify & Submit"}
//           </button>
//         </div>
//       )}

//       {/* DONE */}
//       {step === "DONE" && (
//         <div style={{ marginTop: 20, color: "green", fontWeight: 700 }}>
//           ✅ Response recorded successfully
//         </div>
//       )}

//       {!canRespond && (
//         <div style={{ marginTop: 12, color: "#555" }}>
//           Responses are disabled (expired or already responded).
//         </div>
//       )}
//     </div>
//   );
// }















































import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export default function PublicLogView() {
  const { publicId } = useParams();

  // ===============================
  // DATA STATE
  // ===============================
  const [loading, setLoading] = useState(true);
  const [log, setLog] = useState(null);
  const [events, setEvents] = useState([]);
  const [canRespond, setCanRespond] = useState(false);
  const [error, setError] = useState("");

  // ===============================
  // UI FLOW STATE
  // ===============================
  const [step, setStep] = useState("VIEW"); // VIEW | EMAIL | OTP | DONE
  const [action, setAction] = useState(null); // AGREE | DISAGREE
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [busy, setBusy] = useState(false);

  // ===============================
  // LOAD PUBLIC LOG
  // ===============================
  const fetchPublic = async () => {
    setLoading(true);
    setError("");

    try {
      const fn = httpsCallable(functions, "getPublicLog");
      const res = await fn({ publicId });

      setLog(res.data.log || null);
      setEvents(res.data.events || []);
      setCanRespond(Boolean(res.data.canRespond));
    } catch (err) {
      console.error("getPublicLog error:", err);
      setError(
        err?.message ||
        err?.details ||
        "Failed to load public log"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPublic();
    // eslint-disable-next-line
  }, [publicId]);

  // ===============================
  // SEND OTP (STEP 1)
  // ===============================
  const sendOtp = async () => {
    if (!action) {
      alert("Action missing. Please select Agree or Disagree.");
      return;
    }

    if (!email.trim()) {
      alert("Please enter your email");
      return;
    }

    setBusy(true);
    setError("");

    try {
      const fn = httpsCallable(functions, "sendEmailOtp");
      await fn({ publicId, email, action });

      setStep("OTP");
    } catch (err) {
      console.error("sendEmailOtp error:", err);
      setError(
        err?.message ||
        err?.details ||
        "Failed to send OTP"
      );
    } finally {
      setBusy(false);
    }
  };

  // ===============================
  // VERIFY OTP (STEP 2)
  // ===============================
  const verifyOtp = async () => {
    if (!otp.trim()) {
      alert("Please enter the OTP");
      return;
    }

    setBusy(true);
    setError("");

    try {
      const fn = httpsCallable(functions, "verifyEmailOtpAndRespond");
      await fn({ publicId, email, otp });

      setStep("DONE");
      await fetchPublic();
    } catch (err) {
      console.error("verifyEmailOtpAndRespond error:", err);
      setError(
        err?.message ||
        err?.details ||
        "OTP verification failed"
      );
    } finally {
      setBusy(false);
    }
  };

  // ===============================
  // UI STATES
  // ===============================
  if (loading) {
    return <div style={{ padding: 40 }}>Loading…</div>;
  }

  if (error) {
    return (
      <div style={{ padding: 40, color: "red" }}>
        {error}
      </div>
    );
  }

  if (!log) {
    return <div style={{ padding: 40 }}>Log not found</div>;
  }

  // ===============================
  // RENDER
  // ===============================
  return (
    <div style={{ padding: 24, maxWidth: 900, margin: "0 auto" }}>
      <h2>Public Log</h2>

      {/* LOG SUMMARY */}
      <div
        style={{
          border: "1px solid #ddd",
          borderRadius: 12,
          padding: 14,
        }}
      >
        <div style={{ fontWeight: 800, fontSize: 18 }}>
          {log.title}
        </div>

        {log.note && (
          <div style={{ marginTop: 6 }}>{log.note}</div>
        )}

        <div style={{ marginTop: 10, fontSize: 12, opacity: 0.7 }}>
          Expired: {String(Boolean(log.expired))}
        </div>
      </div>

      {/* TIMELINE */}
      <h3 style={{ marginTop: 20 }}>Timeline</h3>
      <div
        style={{
          border: "1px solid #eee",
          borderRadius: 12,
          padding: 12,
        }}
      >
        {events.length === 0 ? (
          <div>No events yet</div>
        ) : (
          events.map((ev) => (
            <div key={ev.id} style={{ padding: "8px 0" }}>
              <b>{ev.event_type}</b>
              <div style={{ fontSize: 12, opacity: 0.7 }}>
                {ev.timestamp?.toDate
                  ? ev.timestamp.toDate().toLocaleString()
                  : ""}
              </div>
            </div>
          ))
        )}
      </div>

      {/* ACTION BUTTONS */}
      {step === "VIEW" && canRespond && (
        <div style={{ marginTop: 18, display: "flex", gap: 10 }}>
          <button
            onClick={() => {
              setAction("AGREE");
              setStep("EMAIL");
            }}
          >
            ✅ Agree
          </button>

          <button
            onClick={() => {
              setAction("DISAGREE");
              setStep("EMAIL");
            }}
          >
            ❌ Disagree
          </button>
        </div>
      )}

      {/* EMAIL STEP */}
      {step === "EMAIL" && (
        <div style={{ marginTop: 20 }}>
          <h4>Email verification</h4>

          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ padding: 8, width: 260 }}
          />

          <br /><br />

          <button disabled={busy} onClick={sendOtp}>
            {busy ? "Sending…" : "Send OTP"}
          </button>
        </div>
      )}

      {/* OTP STEP */}
      {step === "OTP" && (
        <div style={{ marginTop: 20 }}>
          <h4>Enter OTP</h4>

          <input
            type="text"
            placeholder="6-digit OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            style={{ padding: 8, width: 180 }}
          />

          <br /><br />

          <button disabled={busy} onClick={verifyOtp}>
            {busy ? "Verifying…" : "Verify & Submit"}
          </button>
        </div>
      )}

      {/* DONE */}
      {step === "DONE" && (
        <div style={{ marginTop: 20, color: "green", fontWeight: 700 }}>
          ✅ Response recorded successfully
        </div>
      )}

      {/* EXPIRED / DISABLED */}
      {!canRespond && (
        <div style={{ marginTop: 12, color: "#555" }}>
          Responses are disabled.  
          If no response was submitted before expiry, the system automatically recorded <b>Ignore</b>.
        </div>
      )}
    </div>
  );
}
